import { useEffect } from 'react';

const ConvoCoreWidget = () => {
  useEffect(() => {
    // Check if we're in a development or preview environment
    const hostname = window.location.hostname;
    const isDevelopment = hostname === 'localhost' || 
                         hostname.includes('webcontainer-api.io') || 
                         hostname.includes('127.0.0.1');
    
    // Load the widget in most environments (excluding only localhost and webcontainer)
    if (isDevelopment) {
      console.log('Voiceflow widget disabled in development/preview environment');
      return;
    }

    // Set up ConvoCore configuration
    window.VG_CONFIG = {
      ID: "Da8748iz6EthZRxYksn0", // YOUR AGENT ID
      region: 'na', // YOUR ACCOUNT REGION 
      render: 'bottom-right', // Widget position
      // modalMode: true, // Set this to 'true' to open the widget in modal mode
      stylesheets: [
        "https://vg-bunny-cdn.b-cdn.net/vg_live_build/styles.css"
      ],
      // THIS IS SUPPOSED TO BE CHANGED OR REMOVED.
      // user: {
      //     name: 'John Doe', // User's name
      //     email: 'johndoe@gmail.com', // User's email
      //     phone: '+1234567890', // User's phone number
      // }
      // Optional user data -- end
      // **
      // userID: 'USER_ID', // If you want to use your own user_id
      // autostart: true, // Whether to autostart the chatbot with the proactive message
    };

    // Create and load the ConvoCore script
    const VG_SCRIPT = document.createElement("script");
    VG_SCRIPT.src = "https://vg-bunny-cdn.b-cdn.net/vg_live_build/vg_bundle.js";
    VG_SCRIPT.defer = true; // Remove 'defer' if you want widget to load faster (Will affect website loading)
    document.body.appendChild(VG_SCRIPT);

    // Cleanup function
    return () => {
      if (VG_SCRIPT.parentNode) {
        VG_SCRIPT.parentNode.removeChild(VG_SCRIPT);
      }
      // Clean up global config
      if (window.VG_CONFIG) {
        delete window.VG_CONFIG;
      }
    };
  }, []);

  // Render the container div where ConvoCore will render the widget
  return (
    <div style={{ width: 0, height: 0 }} id="VG_OVERLAY_CONTAINER">
      {/* Here is where CONVOCORE renders the widget. */}
      {/* Set render to 'full-width' then adjust the width and height to 500px (for example) to render the chatbot itself without the popup. */}
    </div>
  );
};

// Add type declaration for window.VG_CONFIG
declare global {
  interface Window {
    VG_CONFIG: {
      ID: string;
      region: string;
      render: string;
      modalMode?: boolean;
      stylesheets: string[];
      user?: {
        name: string;
        email: string;
        phone: string;
      };
      userID?: string;
      autostart?: boolean;
    };
  }
}

export default ConvoCoreWidget;